module.exports = __webpack_public_path__ + "static/media/cover.92a765b5.png";